//@flow
import * as React from 'react';
import Settings from 'config/Settings'
import { applyOptionCode, loadModel } from 'utils/vrUtils';

const SessionStateContext: Object = React.createContext(null);
const SessionDispatchContext: Object = React.createContext(null);

export type OptionType = {
  color: number,
  wheel: number,
  bg: number,
  lamp: boolean,
  door: boolean,
  seat: number,
  option: number,
  o01: boolean,
  o02: boolean,
  o03: boolean,
  o04: boolean,
  ambient: number,
  ambientOn: boolean,
  iseat: number,
  position: number,
}

export type StateType = {
  modelIndex: number,
  defaultOptions: Array<OptionType>,
  options: OptionType | Object
}

type ActionType =
  | {type: 'SELECT_MODEL', data: string}
  | {type: 'SELECT_OPTION', data: string, option: string}
  | {type: 'SELECT_OPTION_DATA', data: boolean | number, option: string}
;
function sessionReducer(state: StateType, action: ActionType) {
  if (process.env.NODE_ENV !== "production") {
    console.log('session', action, state)
  }
  switch (action.type) {
    case 'SELECT_MODEL':
      const idx = Settings.models.indexOf(action.data);
      console.assert(idx >= 0 && idx < Settings.models.length);
      if (idx >= 0) {

        // const colorCode = getExteriorColorCode(state.selectedColorIndices, action.data);
        // console.warn("will apply color code", colorCode);
        if (state.modelIndex !== idx) {
          const options = state.defaultOptions[idx];
          const carOptions = {
            color: options.color,
            wheel: options.wheel,
            bg: options.bg,
            lamp: options.lamp,
            door: options.door,
            seat: options.seat,
            ambient: options.ambient,
            ambientOn: options.ambientOn,
            position: options.position
          };
          const carOptionsCodes = {
            color: Settings.colorCodes[idx][options.color],
            wheel: Settings.wheelCodes[idx][options.wheel],
            bg: Settings.bgCodes[idx][options.bg],
            lamp: options.lamp,
            door: options.door,
            seat: Settings.seatCodes[idx][options.seat],
            ambient: options.ambient,
            ambientOn: options.ambientOn,
            position: Settings.positionCodes[idx][options.position]
          };
          loadModel(action.data, carOptions, carOptionsCodes);
        }
        return {...state, modelIndex: idx, options: state.defaultOptions[idx]};
      }
      return state;
    case 'SELECT_OPTION':
        const codes = Settings[`${action.option}Codes`];
        const index = codes[state.modelIndex].indexOf(action.data);
        console.assert(index >= 0 && index < codes[state.modelIndex].length);
        let options: Object = state.options;
        if (options[action.option] !== index) {
          options[action.option] = index;
          applyOptionCode(action.option, action.data, index, state.options )
          //applyCarColorCode(colorCode);
          return {...state, options: options};
        }
        return state;
    case 'SELECT_OPTION_DATA':
      let optionsB: Object = state.options;
      if (optionsB[action.option] !== action.data) {
        optionsB[action.option] = action.data;

        applyOptionCode(action.option, action.data, -1, optionsB);
        return {...state, options: optionsB};
      }
      return state;
    default:
      return state;
  }
}

function sessionInit(): StateType {
  const defaultModelIdx = 0;
  let defaultOptions: Array<OptionType> = [];
  const defaultColors = Settings.models.map((model, index) => Settings.colorCodes[index].indexOf(Settings.defaultColorCodes[index]));
  const defaultWheels = Settings.models.map((model, index) => Settings.wheelCodes[index].indexOf(Settings.defaultWheelCodes[index]));
  const defaultBgs = Settings.models.map((model, index) => Settings.bgCodes[index].indexOf(Settings.defaultBgCodes[index]));
  const defaultSeats = Settings.models.map((model, index) => Settings.seatCodes[index].indexOf(Settings.defaultSeatCodes[index]));
  for (let i = 0; i < Settings.models.length; ++i) {
    defaultOptions.push({
      color: defaultColors[i],
      wheel: defaultWheels[i],
      bg: defaultBgs[i],
      lamp: false,
      door: false,
      seat: defaultSeats[i],
      option: 0,
      o01: false,
      o02: false,
      o03: false,
      o04: false,
      ambient: 0.0,
      ambientOn: false,
      iseat: 0,
      position: 0
    });
  }

  return {
    modelIndex: -1,
    defaultOptions: defaultOptions,
    options: defaultOptions[defaultModelIdx]
  }
}

type Props = {
  children: React.Node
}

export default function Session(props: Props): React.Element<any> {
  const [state, dispatch] = React.useReducer(sessionReducer, {}, sessionInit);
  return (
    <SessionStateContext.Provider value={state}>
      <SessionDispatchContext.Provider value={dispatch}>
        {props.children}
      </SessionDispatchContext.Provider>
    </SessionStateContext.Provider>
  );
}

export function useSessionState(): StateType {
  const state = React.useContext(SessionStateContext);
  if (!state) {
    throw new Error('Cannot find SessionProvider');
  }
  return state;
}

export function useSessionDispatch(): (ActionType) => void {
  const dispatch = React.useContext(SessionDispatchContext);
  if (!dispatch) {
    throw new Error('Cannot find SessionProvider');
  }
  return dispatch;
}
